var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTileTownhall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 15.9152,
    viewBox: "0 0 16 15.9152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Container"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Symbol",
    d: "M14 0H2C1.4375 0.0208333 0.96875 0.21875 0.59375 0.59375C0.21875 0.96875 0.0208333 1.42708 0 1.96875V10.9375C0.0208333 11.5 0.21875 11.9688 0.59375 12.3438C0.96875 12.7188 1.4375 12.9062 2 12.9062H5V15.5312C5.02083 15.6979 5.09375 15.8125 5.21875 15.875C5.34375 15.9375 5.46875 15.9271 5.59375 15.8438L9.5 12.9062H14C14.5625 12.9062 15.0312 12.7188 15.4062 12.3438C15.7812 11.9688 15.9792 11.5 16 10.9375V1.96875C15.9792 1.42708 15.7917 0.96875 15.4375 0.59375C15.0625 0.21875 14.5833 0.0208333 14 0V0V0M14.5312 11C14.5104 11.3125 14.3438 11.4792 14.0312 11.5H9.03125L6.53125 13.375V11.5H2.03125C1.71875 11.4792 1.55208 11.3125 1.53125 11V2C1.55208 1.6875 1.71875 1.52083 2.03125 1.5H14.0312C14.3438 1.52083 14.5104 1.6875 14.5312 2V11V11V11",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTileTownhall);
export default __webpack_public_path__ + "static/media/tile-townhall.b2a3d1617e7a38af36f8840749dccc97.svg";
export { ForwardRef as ReactComponent };